module.exports = __webpack_public_path__ + "static/img/icon_6.823f393.png";


//////////////////
// WEBPACK FOOTER
// ./static/order/icon_6.png
// module id = 8Eax
// module chunks = 1